import {Injectable} from '@angular/core';
import {Crud} from './crud';
import {Observable} from 'rxjs';
import {CrudNewImplementation} from '@shared/services/crud-new-implementation';

@Injectable({
  providedIn: 'root'
})
export class CrudMarketsService extends CrudNewImplementation {
  protected url = '/v1/admin/markets';

  getUserToolMarkets(userName: string, toolGroup: string, mandant: string, envname: string): Observable<any> {
    const url = `/v1/markets?q=username:${userName},toolgroup:${toolGroup},mandant:${mandant},envname:${envname}&querytype=strict&resulttype=id`;

    console.log('getUserToolMarkets: ' + url);

    return this.http.get(this.serverRoot + url);
  }

  setUserToolMarkets(userid: string, toolid: string, selectedMarkets: any): Observable<any> {
    // console.log('set user tool market');
    // console.log(userid);
    // console.log(toolid);
    // console.log(selectedMarkets);
    const url = '/v1/admin/users/' + userid + '/tools/' + toolid + '/markets';
    return this.http.post(this.serverRoot + url, {selectedusermarkets: selectedMarkets});
  }

  getActiveMarkets(): Observable<any> {
    const url = '/v1/admin/markets?active=1';
    return this.http.get(this.serverRoot + url);
  }

}
